exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".setting-form[data-v-1990533a]  .el-form-item__label{font-size:13px;overflow:hidden;white-space:nowrap}.setting-form[data-v-1990533a]  .el-form-item--mini.el-form-item{margin-bottom:6px}.setting-form .radio-group-custom[data-v-1990533a]  .el-radio-button__inner{padding-left:12px;padding-right:12px}.setting-form .custom-divider.el-divider--horizontal[data-v-1990533a]{margin:10px 0}.setting-collapse[data-v-1990533a]  .el-collapse-item__content{padding-bottom:6px}.setting-collapse[data-v-1990533a]  .el-collapse-item__header{font-weight:bold}.small-padding-dialog[data-v-1990533a]  .el-dialog__body{padding:6px 15px 12px 15px}\n", ""]);

// exports
